export var LicenseType;
(function (LicenseType) {
    LicenseType[LicenseType["ADUser"] = 1] = "ADUser";
    LicenseType[LicenseType["LDSUser"] = 2] = "LDSUser";
})(LicenseType || (LicenseType = {}));
//# sourceMappingURL=license.js.map